import { isNotDefined, isNotEmpty, type GameRelevantListSuccess } from '@terros/common'
import { useCompetitionWidgetGames } from './relevant'

export type CompetitionWidgetState = 'games' | 'create' | 'hidden'

/**
 * Hidden when there is nothing to show and nothing to offer: a viewer who can't create a competition and has none to
 * look at has no use for the widget. A viewer who can create one gets a way to start it instead.
 */
export function getCompetitionWidgetState({
  games,
  canCreate,
}: Pick<GameRelevantListSuccess, 'games' | 'canCreate'>): CompetitionWidgetState {
  if (isNotEmpty(games)) return 'games'
  if (canCreate) return 'create'
  return 'hidden'
}

/**
 * Whether a feed should render its competition widgets. Stays true until the competitions load, and when they fail to,
 * so the card can say so.
 */
export function useIsCompetitionWidgetVisible(enabled: boolean): boolean {
  const { data } = useCompetitionWidgetGames(enabled)
  if (!enabled || isNotDefined(data)) return true
  return getCompetitionWidgetState(data) !== 'hidden'
}
